import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from 'app/exercise-program/services/document.service';
import { Record } from 'fitforce-offline-first';

@Component({
  selector: 'add-category-dialog',
  templateUrl: './add-category-dialog.component.html',
  styleUrls: ['./add-category-dialog.component.scss'],
})
export class AddCategoryDialogComponent implements OnInit {
  categoryNames: FormControl;

  get exerciseCategories(): Record[] {
    if (this.documentService.store.exerciseProgram) {
      return this.documentService.store.exerciseProgram.document.exercise_categories.filter(cat => !['PFT', 'CFT'].includes(cat.name));
    }
  }

  constructor(
    private documentService: DocumentService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AddCategoryDialogComponent>
  ) { }

  ngOnInit() {
    if (!this.documentService.store.exerciseProgram) {
      this.documentService.restoreData().subscribe();
    }

    this.categoryNames = this.formBuilder.control('', [Validators.required]);
  }

  submit() {
    this.dialogRef.close(this.categoryNames.value.split(',').map(s => s.trim()));
  }

  cancel() {
    this.dialogRef.close();
  }
}
